// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { ProductionDeclarationLayout } from '@/features/production-declaration/layouts/production-declaration-layout';
import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'production-declarations/$id',
  component: () => <ProductionDeclarationLayout />,
});
